import type { Calendar } from './calendar';

/**
 * @since 7.1.0
 */
export type RemindersList = Calendar;
